import ProductCardGalllerySearch from "@/components/Molecules/ProductCardGalllerySearch";
import { StyledContent, StyledContentProductsColumn } from "./styles";
import { pulseBridgeToCart } from "@/utils/product";
import Paragraph from "@/components/Atoms/Paragraph";
import ProductCardGallerySearchSkeleton from "@/components/Atoms/ProductCardGallerySearchSkeleton";
import { useQuery } from "@tanstack/react-query";
import Heading from "@/components/Atoms/Heading";
import { getSimilarProducts } from "@/services/pulseBridge";
import some from "lodash.some";

interface QueryReturnType {
  items: Cart[];
}

const RecomendedOneProduct = ({
  product,
  storeId,
  items: itemsCheckout,
}: {
  product: Cart;
  storeId: number;
  items: Cart[];
}) => {
  const { data, error, isFetching } = useQuery<QueryReturnType>({
    queryKey: ["itemOutOfStock", storeId, product.product.id],
    queryFn: async () => {
      const result = await getSimilarProducts(product.product.sku, storeId, 6);
      const outOfStockSkus = new Set(itemsCheckout.map((item) => item.product.sku));
      const items: Cart[] = result.data.data
        .map(pulseBridgeToCart)
        .filter((item) => !some(outOfStockSkus, (sku) => sku === item.product.sku))
        .slice(0, 3);
      return { items };
    },
    enabled: !!storeId && !!product.product.id,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });

  return (
    <StyledContent tw="bg-secondary-100 overflow-y-scroll">
      <ProductCardGalllerySearch item={product} disabled showUnits showButtonCart={false} />

      {data && data?.items.length >= 1 && (
        <Paragraph sizeVariant="md" fontWeight={400}>
          Pero no te preocupes, tenemos estas recomendaciones para ti
        </Paragraph>
      )}

      <StyledContentProductsColumn>
        {(isFetching || !storeId || !product.product.id) &&
          Array.from({ length: 3 }).map((_, index) => <ProductCardGallerySearchSkeleton key={index} />)}

        {error !== null && (
          <Paragraph sizeVariant="md">Ocurrió un error al cargar las recomendaciones</Paragraph>
        )}

        {data && data?.items?.length <= 0 && <Heading type="h6">No hay recomendaciones disponibles</Heading>}

        {data?.items.map((item, index) => (
          <ProductCardGalllerySearch key={index} item={item} />
        ))}
      </StyledContentProductsColumn>
    </StyledContent>
  );
};

export default RecomendedOneProduct;
